var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144.176,
    height: 249,
    viewBox: "0 0 144.176 249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-867.745 -355)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(745.891 354.999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.731,5.107,221.7,1.082a4.879,4.879,0,0,0-6.127,0l-7.7,6.16-7.7-6.16a4.878,4.878,0,0,0-6.127,0l-7.7,6.16-7.7-6.16a4.878,4.878,0,0,0-6.127,0l-7.7,6.16-7.7-6.16a4.878,4.878,0,0,0-6.127,0l-7.7,6.16-7.7-6.16a4.879,4.879,0,0,0-6.127,0L124.433,5.1a6.832,6.832,0,0,0-2.578,5.362V178.939a2.943,2.943,0,0,0,5.885,0V35.766h95.684v30.11a2.943,2.943,0,1,0,5.885,0V10.469a6.834,6.834,0,0,0-2.578-5.362ZM127.739,29.88V10.466a.975.975,0,0,1,.368-.766l4.415-3.532,7.7,6.159a4.878,4.878,0,0,0,6.127,0l7.7-6.16,7.7,6.159a4.877,4.877,0,0,0,6.127,0l7.7-6.16,7.7,6.159a4.878,4.878,0,0,0,6.127,0l7.7-6.16,7.7,6.159a4.876,4.876,0,0,0,6.127,0l7.7-6.159L223.055,9.7a.976.976,0,0,1,.368.766V29.881H127.739Z",
    transform: "translate(-0.001 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.366,142.3a2.943,2.943,0,0,0-2.943,2.943V279.9a.978.978,0,0,1-.368.766L218.64,284.2l-7.7-6.159a4.877,4.877,0,0,0-6.127,0l-7.7,6.16-7.7-6.159a4.877,4.877,0,0,0-6.127,0l-7.7,6.16-7.7-6.16a4.878,4.878,0,0,0-6.127,0l-7.7,6.16-7.7-6.159a4.877,4.877,0,0,0-6.127,0l-7.7,6.159-4.418-3.534a.976.976,0,0,1-.368-.766V261.6a2.943,2.943,0,1,0-5.885,0v18.3a6.832,6.832,0,0,0,2.578,5.362l5.031,4.024a4.878,4.878,0,0,0,6.127,0l7.7-6.16,7.7,6.159a4.878,4.878,0,0,0,6.127,0l7.7-6.16,7.7,6.16a4.878,4.878,0,0,0,6.127,0l7.7-6.16,7.7,6.16a4.878,4.878,0,0,0,6.127,0l7.7-6.16,7.7,6.16a4.879,4.879,0,0,0,6.127,0l5.028-4.022a6.834,6.834,0,0,0,2.577-5.362V145.244A2.941,2.941,0,0,0,226.366,142.3Z",
    transform: "translate(0 -85.307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.7,420.729a2.943,2.943,0,1,0,5.885,0V400.476a2.943,2.943,0,1,0-5.885,0Z",
    transform: "translate(-20.888 -238.316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.932,397.533a2.943,2.943,0,0,0-2.943,2.943v20.253a2.943,2.943,0,0,0,5.885,0V400.476a2.942,2.942,0,0,0-2.943-2.943Z",
    transform: "translate(-35.451 -238.316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.537,400.476v20.253a2.943,2.943,0,1,0,5.885,0V400.476a2.943,2.943,0,1,0-5.885,0Z",
    transform: "translate(-57.96 -238.316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.853,423.671a2.943,2.943,0,0,0,2.943-2.943V400.476a2.943,2.943,0,1,0-5.885,0v20.253A2.943,2.943,0,0,0,241.853,423.671Z",
    transform: "translate(-70.174 -238.316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.253,400.476v20.253a2.943,2.943,0,1,0,5.885,0V400.476a2.943,2.943,0,1,0-5.885,0Z",
    transform: "translate(-85.966 -238.316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.4,400.476v20.253a2.943,2.943,0,1,0,5.885,0V400.476a2.943,2.943,0,1,0-5.885,0Z",
    transform: "translate(-114.229 -238.316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.552,397.533a2.943,2.943,0,0,0-2.943,2.943v20.253a2.943,2.943,0,0,0,5.885,0V400.476a2.942,2.942,0,0,0-2.943-2.943Z",
    transform: "translate(-131.141 -238.316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.64,115.062h16.181a2.943,2.943,0,1,0,0-5.885H159.64a2.943,2.943,0,1,0,0,5.885Z",
    transform: "translate(-20.888 -65.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.64,149.885h24.768a2.943,2.943,0,1,0,0-5.885H159.64a2.943,2.943,0,1,0,0,5.885Z",
    transform: "translate(-20.888 -86.326)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.64,184.708h12.384a2.943,2.943,0,1,0,0-5.885H159.64a2.943,2.943,0,1,0,0,5.885Z",
    transform: "translate(-20.888 -107.202)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.64,342.857h12.384a2.943,2.943,0,1,0,0-5.885H159.64a2.943,2.943,0,1,0,0,5.885Z",
    transform: "translate(-20.888 -202.011)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.64,260.144H182a2.943,2.943,0,1,0,0-5.885H159.64a2.943,2.943,0,1,0,0,5.885Z",
    transform: "translate(-20.888 -152.425)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.052,216.541h-9.639a2.943,2.943,0,0,0,0,5.885h9.639a2.943,2.943,0,0,0,0-5.885Z",
    transform: "translate(-21.351 -129.814)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.818,216.541h-9.639a2.943,2.943,0,1,0,0,5.885h9.639a2.943,2.943,0,0,0,0-5.885Z",
    transform: "translate(-52.984 -129.814)",
    fill: "#cfae26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.71,222.426h9.639a2.943,2.943,0,0,0,0-5.885H318.71a2.943,2.943,0,0,0,0,5.885Z",
    transform: "translate(-116.249 -129.814)",
    fill: "#3158d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.944,222.426h9.639a2.943,2.943,0,0,0,0-5.885h-9.639a2.943,2.943,0,0,0,0,5.885Z",
    transform: "translate(-84.616 -129.814)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.761,294.92a2.942,2.942,0,0,0-2.943-2.943h-9.639a2.943,2.943,0,1,0,0,5.885h9.639a2.943,2.943,0,0,0,2.943-2.943Z",
    transform: "translate(-52.984 -175.037)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.413,291.976a2.943,2.943,0,1,0,0,5.885h9.639a2.943,2.943,0,1,0,0-5.885Z",
    transform: "translate(-21.351 -175.036)",
    fill: "#e15554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.944,297.862h9.639a2.943,2.943,0,0,0,0-5.885h-9.639a2.943,2.943,0,1,0,0,5.885Z",
    transform: "translate(-84.616 -175.037)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.71,297.862h9.639a2.943,2.943,0,0,0,0-5.885H318.71a2.943,2.943,0,1,0,0,5.885Z",
    transform: "translate(-116.249 -175.037)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.594,340.059A2.942,2.942,0,0,0,302.537,343h16.939a2.943,2.943,0,1,0,0-5.885H302.537A2.942,2.942,0,0,0,299.594,340.059Z",
    transform: "translate(-106.553 -202.097)",
    fill: "#4dccbd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.913,46.671H202.937a2.943,2.943,0,0,0,0,5.885h38.976a2.943,2.943,0,1,0,0-5.885Z",
    transform: "translate(-46.844 -27.978)",
    fill: "#cfae26"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19978.078 15320.158)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51.921,
    cy: 51.921,
    r: 51.921,
    transform: "translate(-19070 -14820)",
    fill: "#4dccbd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.989,39.392a4.581,4.581,0,0,1-3.252-1.348L1.348,24.655a4.6,4.6,0,0,1,6.494-6.5L18.018,28.327,44.978,1.348a4.6,4.6,0,0,1,6.5,6.494l-30.25,30.25a4.581,4.581,0,0,1-3.242,1.3Z",
    transform: "translate(-19044.629 -14787.795)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSvg);
export default __webpack_public_path__ + "static/media/payment-svg.5de499a1a94191ab04fb680d84185fc4.svg";
export { ForwardRef as ReactComponent };